<div class="dateFilterWrapper d-flex  align-items-center" (click)="toggleDateFilter()">
    <img alt="Date" src="assets/core/table-button/date.svg" />
    <div class="dateFilterWrapper-text ps-1 pe-1">
        <span>{{selectedOption! | translate}}</span>
    </div>
    <img class="ms-auto" alt="Sort" src="assets/core/table-button/sort.svg" />
</div>
@if(isDateFilterOpen){
<div class="overlay-light" (click)="toggleDateFilter()"></div>
<div class="dateFilter-container">
    <div class="dateFilter-items d-flex justify-content-start p-2 ps-3" *ngFor="let item of dateRangeTypesDictionary"
        (click)="toggleDateFilter(item)">
        <span class="text">{{ item | translate }}</span>
    </div>
</div>
}